module.exports = __webpack_public_path__ + "static/media/logo.86046aee.png";